module.exports = __webpack_public_path__ + "static/media/dragDropIcon.bc53a1e0.svg";